import React from 'react';

const containerSecondary = (props) => (
    <div className={`u-flex f-fill f-column justify-content-between u-height100Percent`}>
        {props.children}
    </div>
);

export default containerSecondary;


// WEBPACK FOOTER //
// ./src/components/Flight/UI/Mobile/Tuple/ContainerSecondary/ContainerSecondary.js